module.exports = __webpack_public_path__ + "img/doc-blue-icon.180431e0.svg";